export default "__VITE_ASSET__1f09ed6a__"